import { H1, Text } from 'components'
// import { rem } from "polished"
// import styled from "@emotion/styled"
// import { ReactComponent as LogoIcon } from "assets/images/svg/logo-next-retreat.svg"

// const Logo = styled(LogoIcon)`
//   height: ${rem(80)};
//   width: ${rem(250)};
//   margin-bottom: ${rem(20)};
// `

export const OpenOnDesktop = () => {
  return (
    <>
      <H1>Please open this page on desktop device</H1>

      <Text as="p" textAlign="justify" marginBottom={30}>
        In order to provide best user experience, our venue lister is availible
        only on desktop
      </Text>
    </>
  )
}
